import React from 'react';

import { apiAddExperience } from '../../../../api/experience';
import { routes } from '../../../../routes';

import Experience from './Experience';

export default (props) => (
  <Experience
    submit={apiAddExperience}
    finish={() => props.history.push(routes.certificationsAndTraining.experience.root)}
    {...props}
  />
);
